import { DateTime } from "luxon";

export function formatSqlDate(sqlDate) {
    return sqlDate?DateTime.fromSQL(sqlDate).setLocale('en').toFormat('ccc, DD t'):'N/A';
  }